import React, { Component } from "react";
import { Link } from "react-router";
import Content from "./Content";
import getPath from "../../../shared/utils/getPath";

/* eslint-disable max-len */
export default class DSGVOPage extends Component {
  render() {
    return (
      <Content>
        <div className="info">
          <h2>Datenschutz</h2>
          <p>
            Der Bezirk Oberfranken nimmt den Schutz Ihrer persönlichen Daten
            sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich
            und entsprechend der gesetzlichen Datenschutzvorschriften sowie
            dieser Datenschutzerklärung.
          </p>
          <p>
            Die Nutzung unserer Webseite ist in der Regel ohne Angabe
            personenbezogener Daten möglich. Soweit auf unseren Seiten
            personenbezogene Daten (beispielsweise Name, Anschrift oder
            E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets
            auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
            Zustimmung nicht an Dritte weitergegeben.
          </p>
          <p>
            Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B.
            bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann.
            Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
            nicht möglich.
          </p>
          <p>
            Wir haben technische und organisatorische Maßnahmen getroffen, die
            sicherstellen, dass die Vorschriften über den Datenschutz sowohl von
            uns als auch von unseren externen Dienstleistern beachtet werden.
          </p>
          <p>
            Die Verarbeitung personenbezogener Daten im Bezirk Oberfranken
            erfolgt in Übereinstimmung mit der&nbsp;
            <a
              href="https://eur-lex.europa.eu/legal-content/DE/TXT/PDF/?uri=CELEX:32016R0679&amp;qid=1527147390147&amp;from=EN"
              target="_blank"
              rel="noopener noreferrer"
              title="Externer Link: Gesetzestext auf EU-Lex (Öffnet&nbsp;neues&nbsp;Fenster)"
            >
              Europäischen Datenschutz-Grundverordnung (EU&nbsp;DSGVO)
            </a>
            &nbsp;und dem
            <a
              href="https://www.verkuendung-bayern.de/files/gvbl/2018/08/gvbl-2018-08.pdf"
              target="_blank"
              rel="noopener noreferrer"
              title="Bayerisches Datenschutzgesetz"
            >
              Bayerischen Datenschutzgesetz (BayDSG)
            </a>
            .
          </p>
          <h2>1. Grundlagen</h2>
          <h3>1.1 Verantwortlicher und Datenschutzbeauftragter</h3>
          <p>
            Wenn Sie noch Fragen zum Datenschutz im Zusammenhang mit dieser
            Internetseite haben, können Sie sich an unseren behördlichen
            Datenschutzbeauftragten oder an den Verantwortlichen im Sinne der
            Datenschutzgrundverordnung wenden:
          </p>
          <p>
            Renate Reichert
            <br />
            <strong>Datenschutzbeauftragte des Bezirks Oberfranken</strong>
            <br />
            Cottenbacher Straße 23
            <br />
            95445 Bayreuth
            <br />
            E-Mail:&nbsp;
            <a href="mailto:datenschutz@bezirk-oberfranken.de">
              datenschutz@bezirk-oberfranken.de
            </a>
          </p>
          <p>
            Werner Roder
            <br />
            <strong>
              Stellvertretender Datenschutzbeauftragter des Bezirks
              Oberfranken&nbsp;
            </strong>
            <br />
            Cottenbacher Straße 23
            <br />
            95445 Bayreuth
            <br />
            E-Mail:&nbsp;
            <a href="mailto:datenschutz@bezirk-oberfranken.de">
              datenschutz@bezirk-oberfranken.de
            </a>
          </p>
          <p>
            Matthias Raithel
            <br />
            <strong>
              Verantwortlicher im Sinne der Datenschutzgrundverordnung
            </strong>{" "}
            <br />
            Cottenbacher Straße 23
            <br />
            95445 Bayreuth
            <br />
            E-Mail:&nbsp;
            <a href="mailto:datenschutz@bezirk-oberfranken.de">
              datenschutz@bezirk-oberfranken.de
            </a>
          </p>
          <p>
            Kerstin Krug
            <br />
            <strong>
              Stellvertretende Verantwortliche im Sinne der
              Datenschutzgrundverordnung
            </strong>
            &nbsp;
            <br />
            Cottenbacher Straße 23
            <br />
            95445 Bayreuth
            <br />
            E-Mail:&nbsp;
            <a href="mailto:datenschutz@bezirk-oberfranken.de">
              datenschutz@bezirk-oberfranken.de
            </a>
            &nbsp;
          </p>
          <h3>1.2 Personenbezogene Daten</h3>
          <p>
            Personenbezogene Daten sind alle Informationen, die sich auf eine
            identifizierte oder identifizierbare natürliche Person beziehen. Als
            identifizierbar wird eine natürliche Person angesehen, die direkt
            oder indirekt – insbesondere mittels Zuordnung zu einer Kennung wie
            einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer
            Online-Kennung – identifiziert werden kann.
          </p>
          <h3>1.3 Minderjährigenschutz</h3>
          <p>
            Personen unter 16 Jahren sollten ohne Zustimmung der Eltern oder
            Erziehungsberechtigten keine personenbezogenen Daten an uns
            übermitteln. Die Daten werden nicht an Dritte weitergegeben.
          </p>
          <h3>
            1.4 Rechtsgrundlage für die Verarbeitung personenbezogener Daten
          </h3>
          <p>
            Der Bezirk Oberfranken verarbeitet bei der Wahrnehmung der ihm
            obliegenden im öffentlichen Interesse liegenden Aufgaben
            personenbezogene Daten. Zu den öffentlichen Aufgaben
            des&nbsp;Bezirks Oberfranken gehört insbesondere auch die
            Öffentlichkeitsarbeit und dabei&nbsp;u.a.&nbsp;die Bereitstellung
            von Informationen für die Öffentlichkeit im Rahmen des vorliegenden
            Internetauftritts. Rechtsgrundlage der Verarbeitung ist
            hier&nbsp;Art.&nbsp;6&nbsp;Abs.&nbsp;1 lit. e der
            Datenschutzgrundverordnung der&nbsp;EU&nbsp;(DS-GVO) in Verbindung
            mit der entsprechenden innerstaatlichen oder europäischen
            Aufgabennorm&nbsp;bzw.&nbsp;in Verbindung mit dem BayDSG. Soweit
            eine Verarbeitung personenbezogener Daten im Einzelfall zur
            Erfüllung einer rechtlichen Verpflichtung erforderlich sein sollte,
            dient zudem&nbsp;Art.&nbsp;6&nbsp;Abs.&nbsp;1 lit. c DSGVO in
            Verbindung mit der entsprechenden Rechtsvorschrift, aus der sich die
            rechtliche Verpflichtung ergibt, als Rechtsgrundlage.
          </p>
          <p>
            Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine
            Einwilligung der betroffenen Person einholen,
            dient&nbsp;Art.&nbsp;6&nbsp;Abs.&nbsp;1 lit. a DSGVO als
            Rechtsgrundlage.
          </p>
          <p>
            Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung
            eines Vertrages, dessen Vertragspartei die betroffene Person ist,
            erforderlich ist, dient im Einzelfall
            auch&nbsp;Art.&nbsp;6&nbsp;Abs.&nbsp;1 lit. b DSGVO als
            Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur
            Durchführung vorvertraglicher Maßnahmen erforderlich sind. Als
            zivilrechtliche Vertragspartei wird der Bezirk
            Oberfranken&nbsp;insbesondere im Bereich der Personalgewinnung und
            Beschaffung tätig.
          </p>
          <p>
            Für den Fall, dass lebenswichtige Interessen der betroffenen Person
            oder einer anderen natürlichen Person eine Verarbeitung
            personenbezogener Daten erforderlich machen,
            dient&nbsp;Art.&nbsp;6&nbsp;Abs.&nbsp;1 lit. d DSGVO als
            Rechtsgrundlage.
          </p>
          <h2>2. Datenverarbeitung durch den Besuch dieser Webseite</h2>
          <h3>2.1 Protokollierung</h3>
          <p>
            Bei jedem Zugriff eines Besuchers auf unserem Web-Angebot und bei
            jedem Abruf einer Datei werden Daten über diesen Vorgang
            vorübergehend in einer Protokolldatei verarbeitet.
          </p>
          <p>
            Im Einzelnen werden über jeden Zugriff/Abruf folgende Daten
            gespeichert:
          </p>
          <ul>
            <li>
              Datum und Uhrzeit des Abrufs (Zeitstempel), sowie die IP-Adresse
              des zugreifenden Geräts&nbsp;bzw.&nbsp;Servers
            </li>
            <li>
              Anfragedetails und Zieladresse (Protokollversion, HTTP-Methode,
              Referer, UserAgent-String),
            </li>
            <li>
              Name der abgerufenen Datei und übertragene Datenmenge (angefragte
              URL inkl. Query-String, Größe in Byte) sowie
            </li>
            <li>Meldung, ob der Abruf erfolgreich war (HTTP Status Code).</li>
          </ul>
          <p>
            Wir sind auf Grundlage von Artikel 6 Absatz 1 lit.
            e&nbsp;EU-Datenschutz-Grundverordnung (DSGVO) in Verbindung mit §
            5&nbsp;BSI-Gesetz zur Speicherung der Daten zum Schutz vor Angriffen
            auf die Internetinfrastruktur des&nbsp;Bezirks Oberfranken und der
            Kommunikationstechnik des Bundes über den Zeitpunkt Ihres Besuches
            hinaus verpflichtet. Diese Daten werden analysiert und im Falle von
            Angriffen auf die Kommunikationstechnik zur Einleitung einer Rechts-
            und Strafverfolgung benötigt. Die Daten werden gelöscht, sobald sie
            nicht mehr zur Aufgabenerfüllung benötigt werden.
          </p>
          <p>
            Daten, die beim Zugriff auf das Internetangebot des&nbsp;Bezirks
            Oberfranken protokolliert wurden, werden an Dritte nur übermittelt,
            soweit wir rechtlich dazu verpflichtet sind oder die Weitergabe im
            Falle von Angriffen auf die Kommunikationstechnik des Bundes zur
            Rechts- oder Strafverfolgung erforderlich ist. Eine Weitergabe in
            anderen Fällen erfolgt nicht. Eine Zusammenführung dieser Daten mit
            anderen Datenquellen erfolgt durch den Bezirk Oberfranken nicht.
          </p>
          <p>
            Darüber hinaus machen wir ausdrücklich darauf aufmerksam, dass der
            vom Bezirk Oberfranken auf der Webseite eingebundenen
            Diensteanbieter Vimeo bei der aktiven Nutzung dieser Dienste, wie
            dem Abspielen eines Videos auf der Webseite, Daten der
            Webseitenbesucher des Bezirks Oberfranken entsprechend ihrer
            Datenverwendungsrichtlinien abspeichern und für ihre geschäftlichen
            Zwecke nutzen. Der Bezirk Oberfranken hat keinen Einfluss auf die
            Datenerhebung und deren weitere Verwendung durch die sozialen
            Netzwerke. So bestehen keine Erkenntnisse darüber, in welchem
            Umfang, an welchem Ort und für welche Dauer die Daten gespeichert
            werden, inwieweit die Netzwerke bestehenden Löschpflichten
            nachkommen, welche Auswertungen und Verknüpfungen mit den Daten
            vorgenommen werden und an wen die Daten weitergegeben werden.
          </p>
          <h3>2.3 Webanalyse mit Google Analytics&nbsp;</h3>
          <p>
            Auf Grundlage des&nbsp;Art.&nbsp;6&nbsp;Abs.&nbsp;1 lit. e DSGVO in
            Verbindung mit § 3 Bundesdatenschutzgesetz wertet der Bezirk
            Oberfranken im Rahmen der Öffentlichkeitsarbeit und zur
            bedarfsorientierten Bereitstellung von Informationen zu den
            vom&nbsp;Bezirk Oberfranken wahrzunehmenden Aufgaben
            Nutzungsinformationen zu statistische Zwecken aus.
          </p>
          <p>
            Dies erfolgt mit den Funktionen des Webanalysedienstes Google
            Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway
            Mountain View, CA 94043, USA.
          </p>
          <p>
            Werden Einzelseiten unserer Website aufgerufen, so werden folgende
            Daten gespeichert:
          </p>
          <ul>
            <li>
              zwei Bytes der IP-Adresse des aufrufenden Systems des Nutzers
              (anonym)
            </li>
            <li>die aufgerufene Webseite</li>
            <li>
              die Website, von der der Nutzer auf die aufgerufene Webseite
              gelangt ist (Referrer)
            </li>
            <li>
              die Unterseiten, die von der aufgerufenen Webseite aus aufgerufen
              werden
            </li>
            <li>die Verweildauer auf der Webseite</li>
            <li>die Häufigkeit des Aufrufs der Webseite</li>
          </ul>
          <p>
            Google Analytics verwendet so genannte &quot;Cookies&quot;. Das sind
            Textdateien, die auf Ihrem Computer gespeichert werden und die eine
            Analyse der Benutzung der Website durch Sie ermöglichen. Die durch
            den Cookie erzeugten Informationen über Ihre Benutzung dieser
            Website werden in der Regel an einen Server von Google in den USA
            übertragen und dort gespeichert.
          </p>
          <p>
            Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics
            finden Sie in der Datenschutzerklärung von Google:
            <a
              href="https://support.google.com/analytics/answer/6004245?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://support.google.com/analytics/answer/6004245?hl=de
            </a>
          </p>
          <p>
            Sie können die Speicherung der Cookies durch eine entsprechende
            Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch
            darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche
            Funktionen dieser Website vollumfänglich werden nutzen können. Sie
            können darüber hinaus die Erfassung der durch den Cookie erzeugten
            und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer
            IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch
            Google verhindern, indem Sie das unter dem folgenden Link verfügbare
            Browser-Plugin herunterladen und installieren:
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>
          </p>
          <p>
            Sie können die Erfassung Ihrer Daten durch Google Analytics
            verhindern, indem Sie auf folgenden Link klicken. Es wird ein
            Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei
            zukünftigen Besuchen dieser Website verhindert:
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              title="Browser-Add-on zur Deaktivierung von Google Analytics"
            >
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>
          </p>
          <p>
            Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung
            abgeschlossen und setzen die strengen Vorgaben der deutschen
            Datenschutzbehörden bei der Nutzung von Google Analytics vollständig
            um.
          </p>
          <p>
            Wir nutzen die Funktion &quot;Aktivierung der
            IP-Anonymisierung&quot; auf dieser Webseite. Dadurch wird Ihre
            IPAdresse von Google jedoch innerhalb von Mitgliedstaaten der
            Europäischen Union oder in anderen Vertragsstaaten des Abkommens
            über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in
            Ausnahmefällen wird die volle IP-Adresse an einen Server von Google
            in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers
            dieser Website wird Google diese Informationen benutzen, um Ihre
            Nutzung der Website auszuwerten, um Reports über die
            Websiteaktivitäten zusammenzustellen und um weitere mit der
            Websitenutzung und der Internetnutzung verbundene Dienstleistungen
            gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von
            Google Analytics von Ihrem Browser übermittelte IP-Adresse wird
            nicht mit anderen Daten von Google zusammengeführt.
          </p>
          <h2>
            3. Verarbeitung personenbezogener Daten im Rahmen der
            Kontaktaufnahme
          </h2>
          <p>
            Die Verarbeitung der personenbezogenen Daten geschieht in
            Abhängigkeit des Kontaktweges. Hierbei kann zwischen Kontaktaufnahme
            per E-Mail, per Kontaktformular, per Brief oder Telefon
            unterschieden werden.
          </p>
          <h3>3.1 Kontaktaufnahme per E-Mail</h3>
          <p>
            Informationen, die Sie unverschlüsselt per Elektronische Post
            (E-Mail) an uns senden, können möglicherweise auf dem
            Übertragungsweg von Dritten gelesen werden. Wir können in der Regel
            auch Ihre Identität nicht überprüfen und wissen nicht, wer sich
            hinter einer E-Mail-Adresse verbirgt. Eine rechtssichere
            Kommunikation durch einfache E-Mail ist daher nicht gewährleistet.
            Wir setzen - wie viele E-Mail-Anbieter - Filter gegen unerwünschte
            Werbung („SPAM-Filter“) ein, die in seltenen Fällen auch normale
            E-Mails fälschlicherweise automatisch als unerwünschte Werbung
            einordnen und löschen. E-Mails, die schädigende Programme („Viren“)
            enthalten, werden von uns in jedem Fall automatisch gelöscht.
          </p>
          <p>
            Verwenden Sie für nachweisbare und vertrauliche elektronische
            Kommunikation eine De-Mail. Wenn Sie dem Bezirk Oberfranken eine
            De-Mail senden möchten, benötigen Sie selbst eine De-Mail-Adresse,
            die Sie bei den staatlich zugelassenen De-Mail-Anbietern erhalten.
            Den Bezirk Oberfranken können Sie über&nbsp;
            <strong> bezirk-oberfranken@by.de-mail.de</strong>
            &nbsp;erreichen. Weitere Informationen zur De-Mail können Sie im
            Artikel des Bundesinnenministeriums über &quot;
            <a
              href="https://www.bmi.bund.de/DE/themen/moderne-verwaltung/e-government/de-mail/de-mail-artikel.html;jsessionid=41C8F77E971FA68753FCB44A8B10E5FF.1_cid295"
              target="_blank"
              rel="noopener noreferrer"
              title="De-Mail: sichere und verschlüsselte Kommunikation"
            >
              De-Mail: sichere und ver­schlüsselte Kommunikation
            </a>
            &quot; nachlesen.
          </p>
          <p>
            Soweit Sie einen der oben genannten Kontaktwege verwenden, werden
            die von Ihnen übermittelten Daten (z.B.: Name, Vorname, Anschrift),
            zumindest jedoch die E-Mail-Adresse, sowie die in der E-Mail
            enthaltenen Informationen (inklusive&nbsp;ggf.&nbsp;von Ihnen
            übermittelter personenbezogener Daten) zum Zwecke der
            Kontaktaufnahme und Bearbeitung Ihres Anliegens, gemäß den für die
            Aufbewahrung von Schriftgut geltenden Fristen der&nbsp;
            <a
              href="https://www.bmi.bund.de/SharedDocs/downloads/DE/veroeffentlichungen/themen/moderne-verwaltung/registraturrichtlinie.html"
              title="Registratur­richtlinie für das Bearbeiten und Verwalten von Schriftgut in Bundes­ministerien"
              target="_blank"
              rel="noopener noreferrer"
            >
              Registraturrichtlinie
            </a>
            , die die&nbsp;
            <a
              href="https://www.bmi.bund.de/SharedDocs/downloads/DE/veroeffentlichungen/themen/moderne-verwaltung/ggo.html"
              title="Gemeinsame Geschäftsordnung der Bundesministerien (GGO)"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gemeinsame Geschäftsordnung der Bundesministerien (GGO)
            </a>
            &nbsp;ergänzt, gespeichert.
          </p>
          <p>
            Wir weisen Sie darauf hin, dass die Verarbeitung der Daten auf
            Grundlage von Artikel 6 Absatz 1 lit. e DSGVO in Verbindung mit dem
            BayDSG erfolgt. Eine Verarbeitung der von Ihnen übermittelten
            personenbezogenen Daten ist zum Zweck der Bearbeitung Ihres
            Anliegens erforderlich.
          </p>
          <h3>3.2 E-Mail-Adressen von Dritten</h3>
          <p>
            Auf der Internetseite des&nbsp;Bezirks Oberfranken werden auch
            E-Mail-Adressen von Dritten zu Fachthemen bereitgestellt. Diese
            Adressen enthalten nicht &quot;bezirk-oberfranken.de&quot; nach dem
            @. Sofern Sie eine dieser Adressen zur Kontaktaufnahme verwenden,
            liegt die Verarbeitung der personenbezogenen Daten nicht im
            Verantwortungsbereich des Bezirks Oberfranken. Bei Fragen bzgl. des
            Umgangs mit Ihren personenbezogenen Daten durch diesen Dritten,
            wenden Sie sich entsprechend an diesen.
          </p>
          <h3>3.3 Kontaktaufnahme per Kontaktformular</h3>
          <p>
            Sie können über diese Webseite mit Hilfe eines Kontaktformulars mit
            dem Bezirk Obefranken Kontakt aufnehmen.
          </p>
          <p>
            Die Übermittlung der Inhalte der Kontaktformulare des&nbsp;Bezirks
            Oberfranken erfolgt über eine verschlüsselte https-Verbindung.
          </p>
          <p>
            Soweit Sie das Kontaktformular zur Kommunikation verwenden, ist die
            Angabe einer Ihres Namens sowie Ihrer E-Mail-Adresse erforderlich.
            Ohne diese Daten kann Ihr per Kontaktformular übermitteltes Anliegen
            nicht bearbeitet werden. Die Angabe der Anschrift ist optional und
            ermöglicht uns - soweit von Ihnen gewünscht - die Bearbeitung Ihres
            Anliegens auf postalischem Weg. Daneben werden Datum und Uhrzeit
            Ihrer Anfrage sowie ihre IP-Adresse an uns übermittelt.
          </p>
          <p>
            Sollten wir eine Nachricht über das Kontaktformular oder eine E-Mail
            von Ihnen erhalten, gehen wir davon aus, dass wir zu einer
            Beantwortung per E-Mail berechtigt sind. Ansonsten müssen Sie uns
            ausdrücklich auf eine andere Art der Kommunikation hinweisen. Wir
            weisen Sie darauf hin, dass die Verarbeitung der mit dem
            Kontaktformular übermittelten Daten und des Inhalts
            (welcher&nbsp;ggf.&nbsp;ebenfalls von Ihnen übermittelte
            personenbezogenen Daten enthält) auf Grundlage von Artikel 6 Absatz
            1 lit. a DSGVO zum Zwecke der Bearbeitung Ihres Anliegens erfolgt.
          </p>
          <p>
            Bei Nutzung des Kontaktformulars wird der Inhalt der Datenfelder
            ausschließlich der Internetredaktion des&nbsp;Bezirks Oberfranken
            übermittelt. Die IP-Adresse des Absenders wird dabei erfasst. Dies
            erfolgt grundsätzlich auch beim Absenden einer herkömmlichen E-Mail
            an die Adresse poststelle@bezirk-oberfranken.de. Mit der Aktivierung
            der Checkbox und dem Absenden des Kontaktformulars erklären Sie sich
            gemäß&nbsp;Art.&nbsp;6 Absatz 1 Buchstabe a) DSGVO mit der
            Übermittlung und Speicherung Ihrer personenbezogenen Daten sowie der
            IP-Adresse einverstanden. Verarbeitung und befristete Speicherung
            der personenbezogenen Daten dienen der Beantwortung Ihrer Anfrage im
            Rahmen von Artikel 17 Grundgesetz. Die Verwendung der IP-Adresse
            findet ausschließlich im Rahmen staatlicher Strafverfolgungs- und
            Gefahrenabwehrmaßnahmen unter Beachtung der gesetzlichen
            Voraussetzungen statt.
          </p>
          <p>
            Die Bearbeitung erfolgt durch die Mitarbeiter/innen des Bezirks
            Oberfranken. Die Internetredaktion speichert Ihre Daten nur zur
            Bearbeitung Ihres Anliegens und entsprechend den gesetzlichen und
            vertraglichen Vorgaben.&nbsp;
          </p>
          <p>
            Soweit eine Weiterleitung Ihrer E-Mail zur Bearbeitung Ihres
            Anliegens erfolgt, richtet sich die Verarbeitung nach den für die
            Aufbewahrung von Schriftgut geltenden Fristen.
          </p>
          <p>
            Sollten Sie mit der Verarbeitung Ihrer Daten nicht einverstanden
            sein, können Sie den Kontaktvorgang jederzeit abbrechen. Es erfolgt
            dann keine Versendung Ihrer Nachricht.
          </p>
          <h3>3.5 Kontaktaufnahme per Post</h3>
          <p>
            Sofern Sie an den Bezirk Oberfranken einen Brief schreiben, werden
            die von Ihnen übermittelten Daten (z.B.: Name, Vorname, Anschrift)
            und die im Brief enthaltenen Informationen (ggf.&nbsp;von Ihnen
            übermittelte personenbezogenen Daten) zum Zwecke der Kontaktaufnahme
            und Bearbeitung Ihres Anliegens, gemäß den für die Aufbewahrung von
            Schriftgut geltenden Fristen, gespeichert.
          </p>
          <p>
            Wir weisen Sie darauf hin, dass die Verarbeitung der Daten auf
            Grundlage von Artikel 6 Absatz 1 lit. e DSGVO in Verbindung mit dem
            BayDSG erfolgt. Eine Verarbeitung der von Ihnen übermittelten
            personenbezogenen Daten ist zum Zweck der Bearbeitung Ihres
            Anliegens erforderlich.
          </p>
          <h3>3.6 Kontaktaufnahme per Telefon</h3>
          <p>
            Wenn Sie mit einem/r Beschäftigten per Telefon Kontakt aufnehmen,
            werden, soweit dies erforderlich ist, personenbezogenen Daten von
            Ihnen zur Bearbeitung Ihres Anliegens verarbeitet.
          </p>
          <h2>
            4. Verarbeitung personenbezogener Daten im Rahmen der Nutzung
            sozialer Netzwerke
          </h2>
          <p>
            Der Bezirk Oberfranken ist in den sozialen Netzwerken Instagram,
            Vimeo und Facebook aktiv.
          </p>
          <p>
            Zur redaktionellen Aufgabenerfüllung in den sozialen Netzwerken
            verarbeitet der Bezirk Oberfranken Daten der Personen, die mit dem
            Bezirk Oberfranken in Interaktion treten. Hierbei ist eine temporäre
            Datenspeicherung durch einen Dienstleister notwendig. Die
            Speicherung erfolgt auf einem Server, der seinen Standort in der
            europäischen Union hat und umfasst: Profil- und Accountnamen sowie
            -bild, Inhalt der Anfrage, Anzahl der Follower und der Profile,
            denen das Profil folgt, sowie neueste Beiträge.&nbsp;
          </p>
          <p>
            Wir weisen Sie darauf hin, dass die Verarbeitung der Daten auf
            Grundlage von Artikel 6 Absatz 1 lit. e DSGVO in Verbindung mit dem
            BayDSG erfolgt. Eine Verarbeitung der von Ihnen übermittelten
            personenbezogenen Daten ist zum Zweck der Bearbeitung Ihres
            Anliegens erforderlich.
          </p>
          <p>
            Zudem machen wir ausdrücklich darauf aufmerksam, dass die Dienste
            die Daten ihrer Nutzerinnen und Nutzer (z.B.persönliche
            Informationen, IP-Adresse&nbsp;etc.) entsprechend ihrer
            Datenverwendungsrichtlinien abspeichern und für geschäftliche Zwecke
            nutzen. Der Bezirk Oberfranken hat keinen Einfluss auf die
            Datenerhebung und deren weitere Verwendung durch die sozialen
            Netzwerke. So bestehen keine Erkenntnisse darüber, in welchem
            Umfang, an welchem Ort und für welche Dauer die Daten gespeichert
            werden, inwieweit die Netzwerke bestehenden Löschpflichten
            nachkommen, welche Auswertungen und Verknüpfungen mit den Daten
            vorgenommen werden und an wen die Daten weitergegeben werden.
          </p>
          <p>
            Angaben darüber, welche Daten durch Instagram verarbeitet und zu
            welchen Zwecken genutzt werden, finden Sie in der&nbsp;
            <a
              href="http://instagram.com/about/legal/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              title="Datenschutzerklärung Instagram"
            >
              Datenschutzerklärung von Instagram.
            </a>
          </p>
          <p>
            Angaben darüber, welche Daten durch das Unternehmen Vimeo
            verarbeitet und zu welchen Zwecken genutzt werden, finden Sie in
            der&nbsp;
            <a
              href="https://vimeo.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              title="Datenschutzerklärung Vimeo"
            >
              Datenschutzerklärung von Vimeo
            </a>
            .
          </p>
          <p>
            Angaben darüber, welche Daten durch das Unternehmen Facebook
            verarbeitet und zu welchen Zwecken genutzt werden, finden Sie in
            der&nbsp;
            <a
              href="https://www.facebook.com/policy.php"
              target="_blank"
              rel="noopener noreferrer"
              title="Datenschutzerklärung Facebook"
            >
              Datenschutzerklärung von&nbsp;Facebook
            </a>
            .
          </p>
          <p>
            Dadurch, dass es sich bei den Unternehmen, um außereuropäischen
            Anbieter handelt, die eine europäische Niederlassung nur den USA
            haben, sind diese nach eigener Lesart nicht an deutsche
            Datenschutzvorschriften gebunden. Dies betrifft&nbsp;z.B.&nbsp;Ihre
            Rechte auf Auskunft, Sperrung oder Löschung von Daten oder die
            Möglichkeit einer Verwendung von Nutzungsdaten für Werbezwecke zu
            widersprechen.
          </p>
          <h2>
            5. Verarbeitung von personenbezogenen Daten im Rahmen der
            Informationsbereitstellung
          </h2>
          <h3>5.1 Bestellung von Druckerzeugnissen</h3>
          <p>
            Wenn Sie über diese Webseite Broschüren, Faltblättern und anderen
            Druckerzeugnisse bestellen, ist es erforderlich, Ihre
            personenbezogenen Daten zur Durchführung von vorvertraglichen
            Maßnahmen und zur Vertragserfüllung (Bereitstellung der Erzeugnisse)
            nach Artikel 6 Absatz 1 lit. b DSGVO zu verarbeiten.
          </p>
          <p>
            Zur Bearbeitung des Auftrages sind zwingend folgende
            personenbezogenen Daten anzugeben:
          </p>
          <ul>
            <li>Anrede</li>
            <li>Name, Vorname</li>
            <li>Straße, Hausnummer</li>
            <li>Postleitzahl und Ort</li>
            <li>E-Mail</li>
          </ul>
          <p>
            Diese Daten werden im Rahmen der Bestellung verarbeitet. Soweit die
            Bestellung nicht von uns abschließend bearbeitet werden kann, werden
            die von Ihnen angegebenen Daten an Dritte
            (Versandfirma,&nbsp;ggf.&nbsp;andere Behörden oder Einrichtungen,
            sofern diese das bestellte Material versenden) weitergegeben. Soweit
            die vorgenannten Daten nicht vorliegen, kann die Bearbeitung der
            Bestellung nicht erfolgen. Die zusätzlichen Informationen, wie
            Anrede, Vorname, Firma und Land sind für die Bearbeitung nicht
            erforderlich, dienen jedoch zur besseren Abwicklung der Bestellung.
          </p>
          <p>
            Zur Abwicklung Ihrer Bestellung arbeiten wir mit
            Versand-Dienstleistern zusammen, die uns ganz oder teilweise bei der
            Durchführung geschlossener Verträge unterstützen. An diese
            Dienstleister werden nach Maßgabe der folgenden Informationen
            gewisse personenbezogene Daten übermittelt.
          </p>
          <p>
            Die von uns erhobenen personenbezogenen Daten werden im Rahmen der
            Vertragsabwicklung an das mit der Lieferung beauftragte
            Transportunternehmen weitergegeben, soweit dies zur Lieferung der
            Ware erforderlich ist. Ihre Zahlungsdaten geben wir im Rahmen der
            Zahlungsabwicklung an das beauftragte Kreditinstitut weiter, sofern
            dies für die Zahlungsabwicklung erforderlich ist. Sofern
            Zahlungsdienstleister eingesetzt werden, informieren wir hierüber
            nachstehend explizit. Die Rechtsgrundlage für die Weitergabe der
            Daten ist hierbei Art. 6 Abs. 1 lit. b DSGVO.
          </p>
          <h3>
            5.2 Anmeldung zu museumspädagogischen Programmen oder
            Themenführungen
          </h3>
          <p>
            Wenn Sie sich zu museumspädagogischen Programmen oder
            Themenführungen auf unser Webseite anmelden, geschieht die Buchung
            über das jeweilige Museum. Welche Daten im Rahmen Ihrer Buchung
            erhoben werden, ist vom ausgewählten Museum abhängig. Der Bezirk
            Oberfranken ist hier nicht für Verarbeitung Ihrer Daten
            verantwortlich.{" "}
          </p>
          <h2>6. Verpflichtung der Bezirksmitarbeiter auf den Datenschutz</h2>
          <p>
            Die Mitarbeiterinnen und Mitarbeiter des Bezirks Oberfranken sind
            zur Verschwiegenheit und zur Einhaltung der maßgeblichen
            gesetzlichen Vorschriften des Datenschutzrechts verpflichtet.
          </p>
          <h2>7. Änderung unserer Datenschutzerklärung</h2>
          <p>
            Der Bezirk Oberfranken hat jederzeit das Recht, diese
            Datenschutzerklärung unter Beachtung der geltenden gesetzlichen
            <Link to={getPath("fontend", "dsgvo")}>
              Datenschutzbestimmungen
            </Link>{" "}
            zu ändern.
          </p>
          <h2>8. Ihre Rechte</h2>
          <p>
            Sie haben gegenüber dem&nbsp;Bezirk Oberfranken folgende Rechte
            hinsichtlich der Sie betreffenden personenbezogenen Daten:
          </p>
          <ul>
            <li>
              Recht auf Auskunft,&nbsp;Art.&nbsp;15 DSGVO
              <br />
              Mit dem Recht auf Auskunft erhält der Betroffene eine umfassende
              Einsicht in die ihn angehenden Daten und einige andere wichtige
              Kriterien wie beispielsweise die Verarbeitungszwecke oder die
              Dauer der Speicherung. Es gelten die im BayDSG geregelten
              Ausnahmen von diesem Recht.
            </li>
            <li>
              Recht auf Berichtigung,&nbsp;Art.&nbsp;16 DSGVO
              <br />
              Das Recht auf Berichtigung beinhaltet die Möglichkeit für den
              Betroffenen, unrichtige ihn angehende personenbezogene Daten
              korrigieren zu lassen.
            </li>
            <li>
              Recht auf Löschung,&nbsp;Art.&nbsp;17 DSGVO
              <br />
              Das Recht auf Löschung beinhaltet die Möglichkeit für den
              Betroffenen, Daten beim verantwortlichen löschen zu lassen. Dies
              ist allerdings nur dann möglich, wenn die ihn angehenden
              personenbezogenen Daten nicht mehr notwendig sind, rechtswidrig
              verarbeitet werden oder eine diesbezügliche Einwilligung
              widerrufen wurde. Es gelten die im BayDSG geregelten Ausnahmen von
              diesem Recht.
            </li>
            <li>
              Recht auf Einschränkung der Verarbeitung,&nbsp;Art.&nbsp;18 DSGVO
              <br />
              Das Recht auf Einschränkung der Verarbeitung beinhaltet die
              Möglichkeit für den Betroffenen, eine weitere Verarbeitung der ihn
              angehenden personenbezogenen Daten vorerst zu verhindern. Eine
              Einschränkung tritt vor allem in der Prüfungsphase anderer
              Rechtewahrnehmungen durch den Betroffenen ein.
            </li>
            <li>
              Recht auf Widerspruch gegen die Erhebung, Verarbeitung
              und&nbsp;bzw.&nbsp;oder Nutzung,&nbsp;Art.&nbsp;21 DSGVO
              <br />
              Das Recht auf Widerspruch beinhaltet die Möglichkeit, für
              Betroffene, in einer besonderen Situation der weiteren
              Verarbeitung ihrer personenbezogenen Daten zu widersprechen,
              soweit diese durch die Wahrnehmung öffentlicher Aufgaben oder
              öffentlicher sowie privater Interessen rechtfertigt ist. Es gelten
              die im BayDSG geregelten Ausnahmen von diesem Recht.
            </li>
            <li>
              Recht auf Datenübertragbarkeit,&nbsp;Art.&nbsp;20 DSGVO
              <br />
              Das Recht auf Datenübertragbarkeit beinhaltet die Möglichkeit für
              den Betroffenen, die ihn angehenden personenbezogenen Daten in
              einem gängigen, maschinenlesbaren Format vom Verantwortlichen zu
              erhalten, um sie&nbsp;ggf.&nbsp;an einen anderen Verantwortlichen
              weiterleiten zu lassen. Gemäß&nbsp;Art.&nbsp;20&nbsp;Abs.&nbsp;3
              Satz 2 DSGVO steht dieses Recht aber dann nicht zur Verfügung,
              wenn die Datenverarbeitung der Wahrnehmung öffentlicher Aufgaben
              dient.
            </li>
            <li>
              Recht auf Widerruf der Einwilligung,&nbsp;Art.&nbsp;13 und 14
              DSGVO
              <br />
              Soweit die Verarbeitung der personenbezogenen Daten auf Grundlage
              einer Einwilligung erfolgt, kann der Betroffene diese jederzeit
              für den entsprechenden Zweck widerrufen. Die Rechtmäßigkeit der
              Verarbeitung aufgrund der getätigten Einwilligung bleibt bis zum
              Eingang des Widerrufs unberührt.
            </li>
          </ul>
          <p>
            Die vorgenannten Rechte können Sie unter den unter Ziffer 1.1
            genannten Erreichbarkeiten schriftlich geltend machen.
          </p>
          <p>
            Ihnen steht zudem gemäß&nbsp;Art.&nbsp;77 DSGVO ein Beschwerderecht
            bei der datenschutzrechtlichen Aufsichtsbehörde, der&nbsp;
            <a
              href="http://www.bfdi.bund.de/"
              target="_blank"
              rel="noopener noreferrer"
              title="Webangebot der Bundesbeauftragten für den Datenschutz und die Informationsfreiheit"
            >
              Bundesbeauftragten für den Datenschutz und die
              Informationsfreiheit
            </a>
            , zu.
          </p>
          <p>
            Sie können sich mit Fragen und Beschwerden auch an den unter Ziffer
            1.1 genannten Datenschutzbeauftragten des Bezirks Oberfranken
            wenden.
          </p>
          <p>&nbsp;</p>
        </div>
      </Content>
    );
  }
}
/* eslint-enable max-len */



// WEBPACK FOOTER //
// ./src/frontend/base/components/DSGVOPage.js